<template>
	<div
		class="customizer"
		:style="`background-position: ${backGroundPosition}`"
	>
		<div class="noise"></div>
		<CustomizerWrapper
			v-if="isReady"
			@show-demo-notify="showDemoNotify"
			@show-ar-pop-up="showARPopUp"
		/>

		<div class="header-wrapper">
			<Description
				class="description-wrapper"
			/>

			<WizardSteps
				v-if="isReady"
				class="steps-wrapper"

				@show-demo-notify="showDemoNotify"
				@show-ar-pop-up="showARPopUp"
			/>


		</div>


		<Loader
			class="loader"
			:class="{
				'loader--hidden': loadingState.type === 'loaded'
			}"
		/>

		<CameraChooser
			class="camera-chooser"
			@show-demo-notify="showDemoNotify"
		/>

		<AddToCartBtn
			class="cart-btn"
			:is-rounded="false"

			@click="showDemoNotify"
		/>

		<DemoNotify
			:time-stamp="demoTimeStamp"
		/>

		<Transition
			name="fade"
		>
			<ARPopUp
				v-if="isARPopUpShown"

				@close="closeARPopUp"
			/>
		</Transition>
	</div>
</template>

<script>
import useCustomizer from '@/composables/Customizer';
import Description from '@/components/Customizer/description';
import WizardSteps from '@/components/Customizer/steps';
import { watch, onMounted, ref } from 'vue';
import Loader from '@/components/Customizer/Loader';
import DemoNotify from '@/components/Customizer/DemoNotify';
import AddToCartBtn from '@/components/Customizer/AddToCartBtn';
import CameraChooser from '@/components/CameraChooser';
import ARPopUp from '@/components/Customizer/ARPopUp';
import CustomizerWrapper from './CustomizerWrapper/index';

export default {
	name: 'Customizer',
	components: {
		ARPopUp,
		CameraChooser,
		AddToCartBtn,
		DemoNotify,
		Loader,
		WizardSteps,
		Description,
		CustomizerWrapper,
	},
	setup() {
		const { fetchData, objectsState, loadingState } = useCustomizer({ init: true });
		const isReady = ref(false);
		const demoTimeStamp = ref(0);
		const isARPopUpShown = ref(false);

		const backGroundPosition = ref('');

		watch(objectsState, () => {
			if (!objectsState.value) {
				return;
			}

			backGroundPosition.value = objectsState.value[0].background;
		});

		onMounted(async () => {
			await fetchData();
			isReady.value = true;
		});

		const showDemoNotify = () => {
			demoTimeStamp.value = Date.now();
		};

		const showARPopUp = () => {
			isARPopUpShown.value = true;
		};

		const closeARPopUp = () => {
			isARPopUpShown.value = false;
		};

		return {
			backGroundPosition,

			isReady,
			loadingState,

			showDemoNotify,
			demoTimeStamp,

			isARPopUpShown,
			showARPopUp,
			closeARPopUp,
		};
		// fetchData();
	},

};
</script>

<style lang="sass" scoped>
.customizer
	position: fixed
	top: 0
	left: 0
	right: 0
	bottom: 0
	background: conic-gradient(from 180deg at 50% 50%, #008BDC 0deg, #FF3520 71.25deg, #FF8400 144.37deg, #FFB600 219.37deg, #45BE00 290.63deg, #008BDC 360deg)
	background-size: 250% 300%

	display: flex
	flex-direction: column

	transition: background-position 0.3s

.noise
	position: absolute
	top: 0
	left: 0
	width: 100%
	height: 100%

	background: url('@/assets/noise.png')
	mix-blend-mode: overlay

.header-wrapper
	position: relative
	margin: 80px

	display: flex
	justify-content: space-between

	.description-wrapper
		margin-right: 20px
		margin-bottom: 30px

		@media (max-width: 650px)
			margin-right: 20px
			margin-bottom: 5px

	.steps-wrapper
		flex-shrink: 0

	@media (max-width: 900px)
		margin: 50px

	@media (max-width: 650px)
		flex-direction: column
		margin: 20px 30px

.camera-chooser
	margin: auto auto 50px auto

	@media (max-width: 650px)
		margin-bottom: 30px

.cart-btn
	position: relative
	margin: 0

	@media (min-width: 650px)
		display: none


.loader
	position: absolute
	top: 0
	left: 0
	width: 100%
	height: 100%

	z-index: 10
	transition: transform 1s

	&--hidden
		transform: translateX(120%)
		pointer-events: none
		touch-action: none

.fade-enter-active,
.fade-leave-active
	transition: opacity 0.2s

.fade-enter-from,
.fade-leave-to
	opacity: 0
</style>
